import { render } from "./ContractTemplateRow.vue?vue&type=template&id=0fd5179e&scoped=true"
import script from "./ContractTemplateRow.vue?vue&type=script&lang=js"
export * from "./ContractTemplateRow.vue?vue&type=script&lang=js"

import "./ContractTemplateRow.vue?vue&type=style&index=0&id=0fd5179e&scoped=true&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd5179e"]])

export default __exports__